import React, {useEffect} from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import {
  VIEW_FULL,
  MODULE_DESTINATION,
  MODULE_ROOMS,
  MODULE_DATES,
  MODULE_SPECIAL_RATES,
  FILTER_DESTINATION,
} from './constants';
import ViewByKey from './views/ViewByKey';
import {searchBox} from './drupalSettings';
import syncFilters from 'js/components/shared/actions/syncFilters'
import filterChange from './actions/filterChange';
import prefetchSearchResults from './actions/prefetchSearchResults';
import {pushSearchNavigationClick, pushSearchSubmitError} from '../../helpers/gtm';

const {searchResultsUrl} = searchBox || {};

const MainSearchBox = function ({
  view = VIEW_FULL,
  modules = [MODULE_DESTINATION, MODULE_ROOMS, MODULE_DATES, MODULE_SPECIAL_RATES],
  activeFilter,
  syncFiltersAction,
  filterChangeAction,
  prefetchSearchResultsAction,
  holdKeyword,
}) {
  const onFormSubmit = async function (e) {
    e?.preventDefault()
    await syncFiltersAction(true)
    if (!holdKeyword) {
      pushSearchSubmitError({
        errorField: 'destination',
        errorType: 'blank',
      })
      filterChangeAction('activeFilter', FILTER_DESTINATION)
      return;
    }

    const prefetchData = await prefetchSearchResultsAction();
    pushSearchNavigationClick();

    // if only one hotel available => redirect to room-rates page
    window.location = prefetchData && prefetchData.redirect
      ? prefetchData.redirect
      : `${searchResultsUrl}/${window.location.search}`;
  }

  useEffect(function () {
    syncFiltersAction()

    if (activeFilter) {
      filterChangeAction('activeFilter', activeFilter)
    }
  }, [])

  return (
    <ViewByKey
      type={view}
      modules={modules}
      onSubmit={onFormSubmit}
    />
  )
}

MainSearchBox.propTypes = {
  modules: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(mapModules))),
}

const mapStateToProps = ({main}) => ({
  holdKeyword: main.holdKeyword,
})

const mapDispatchToProps = {
  syncFiltersAction: syncFilters,
  prefetchSearchResultsAction: prefetchSearchResults,
  filterChangeAction: filterChange,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MainSearchBox)
